import React from 'react';
import Slider from 'react-slick'; // Import the slider component

// Import team images
import img1 from '../images/gallery/01.jpg';
import img2 from '../images/gallery/02.jpg';
import img3 from '../images/gallery/03.jpg';
import img4 from '../images/gallery/04.jpg';

const teamMembers = [
  {
    id: 1,
    name: 'Anand Krushi Paryatan Kendra',
    position: 'MORACHI CHINCHOLI, PUNE',
    img: img1,
  },
  {
    id: 2,
    name: 'Anand Krushi Paryatan Kendra',
    position: 'MORACHI CHINCHOLI, PUNE',
    img: img2,
  },
  {
    id: 3,
    name: 'Anand Krushi Paryatan Kendra',
    position: 'MORACHI CHINCHOLI, PUNE',
    img: img4,
  },
  {
    id: 4,
    name: 'Anand Krushi Paryatan Kendra',
    position: 'MORACHI CHINCHOLI, PUNE',
    img: img3,
  },
  {
    id: 5,
    name: 'Anand Krushi Paryatan Kendra',
    position: 'MORACHI CHINCHOLI, PUNE',
    img: img4,
  },
];

const OurTeam = () => {
  const settings = {
    dots: true, // Show navigation dots
    infinite: true, // Infinite looping
    speed: 500, // Speed of transition (ms)
    slidesToShow: 4, // Show 4 items at once
    slidesToScroll: 1, // Scroll one item at a time
    autoplay: true, // Enable autoplay
    autoplaySpeed: 3000, // Autoplay speed (ms)
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3, // 3 items on medium screens
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2, // 2 items on small screens
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1, // 1 item on mobile screens
        },
      },
    ],
  };

  return (
    <section className="our-team pb-0">
      <div className="container">
        <div className=" mb-6 w-75 mx-auto text-center">
          <h4 className="mb-1 theme1">View Our Gallery</h4>
          <h2 className="mb-1">
            Meet Our<span className="theme"> Gallery</span>
          </h2>
          <p>Meet our gallery where you can see the captivating moments captured by our photographers.</p>
        </div>
        <div className="team-main">
          <Slider {...settings}>
            {teamMembers.map((member) => (
              <div className="col-lg-3 col-md-6 col-sm-12 mb-4" key={member.id}>
                <div className="team-list rounded" style={{ margin: '0 15px' }}>
                  <div className="team-image">
                    <img src={member.img} alt={member.name} />
                  </div>
                  <div className="team-content text-center p-3 bg-theme">
                    <h4 className="mb-0 white">{member.name}</h4>
                    <p className="mb-0 white">{member.position}</p>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default OurTeam;
